class LsLoadMore extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    this.addEventListener('click', this.load, { signal: this.abort.signal });
  }
  disconnectedCallback() { this.abort?.abort(); this.request?.abort(); }
  load = async (event) => {
    const link = event.target.closest('[data-next]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (this.busy) return;
    const host = this.closest('results-list');
    const grid = host?.querySelector('[ref="grid"]');
    if (!grid) return;
    this.busy = true;
    link.setAttribute('aria-disabled', 'true');
    link.textContent = this.dataset.loading;
    this.setAttribute('aria-busy', 'true');
    this.querySelector('[data-error]').hidden = true;
    this.request = new AbortController();
    const timeout = setTimeout(() => this.request.abort(), 20000);
    try {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin) throw new Error('Invalid origin');
      url.searchParams.set('section_id', this.dataset.section);
      const response = await fetch(url, { signal: this.request.signal });
      if (!response.ok) throw new Error('Unable to load');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const incoming = doc.querySelector('ls-load-more');
      const cards = [...doc.querySelectorAll('[ref="grid"] > [data-product-id]')];
      if (!incoming || !cards.length) throw new Error('Empty response');
      if (!this.isConnected || !grid.isConnected) return;
      const existing = new Set([...grid.querySelectorAll(':scope > [data-product-id]')].map(card => card.dataset.productId));
      const added = cards.filter(card => !existing.has(card.dataset.productId));
      grid.append(...added);
      const count = grid.querySelectorAll(':scope > [data-product-id]').length;
      const total = Number(incoming.dataset.total);
      this.dataset.count = count;
      this.dataset.total = total;
      this.querySelector('[data-count-label]').textContent = incoming.dataset.label.replace('__COUNT__', String(count));
      const progress = this.querySelector('progress');
      progress.max = total;
      progress.value = count;
      const next = incoming.querySelector('[data-next]');
      if (next) link.href = next.href;
      else link.remove();
    } catch (error) {
      if (this.isConnected) this.querySelector('[data-error]').hidden = false;
    } finally {
      clearTimeout(timeout);
      this.busy = false;
      this.removeAttribute('aria-busy');
      link.removeAttribute('aria-disabled');
      link.textContent = this.dataset.idle;
    }
  };
}
if (!customElements.get('ls-load-more')) customElements.define('ls-load-more', LsLoadMore);
